<template lang="pug">
  .component-credit-record-action-buttons(v-if="item")
    .dropdown-buttons
      ActionButton(:action="expireCredit", v-if="((item.type === 'PAID' || item.type === 'PROMO') && item.status !== 'EXPIRED')", :confirm="true") Expire
      CreditRecordUsageReveal(:item="item")
</template>
<script type="text/babel">

    import ActionButton from '../ActionButton'
    import KeplerBackofficeSdk from '../../../../lib/kepler/backoffice'
    import MaggieHelper from '../../../../maggieHelper'
    import CreditRecordUsageReveal from './reveal/CrediRecordUsageReveal'

    export default {
        name: 'CreditRecordButtons',
        components: {CreditRecordUsageReveal, ActionButton},
        data() {
            return {}
        },
        created() {

        },
        methods: {
            expireCredit() {
                return KeplerBackofficeSdk.credits.select(this.item).expire(() => {
                    MaggieHelper.notification('expire', 'Credit record expired')
                    this.$emit('itemUpdated', 'ciao')
                })
            }
        },
        props: ['item']
    }
</script>
<style lang="sass" rel="stylesheet/sass">

</style>



// WEBPACK FOOTER //
// CreditRecordButtons.vue?6cd6ac9e